import { matchPath, useLocation } from 'react-router-dom';
import { MAIN_SECTIONS, POLICY_LINKS, SETTINGS_LINK } from './AdminNavigation';
import useCountryFilter from './useCountryFilter';

// Everything the sidebar's visual components need, in one place: which
// sections exist, which one is current, and the country filter.
function useAdminSidebar() {
  const { pathname } = useLocation();
  const countryFilter = useCountryFilter();

  const withCurrent = (item) => ({
    ...item,
    isCurrent: !!matchPath(pathname, { path: item.to }),
  });

  return {
    sections: MAIN_SECTIONS.map(withCurrent),
    policies: POLICY_LINKS.map(withCurrent),
    settings: withCurrent(SETTINGS_LINK),
    countryFilter,
  };
}

export default useAdminSidebar;
